import { ChargerEstimatorData } from ".";
import AddressPage from "./formPages/addressPage";
import ChargerLocationPage from "./formPages/chargerLocationPage";
import ContactInformation from "./formPages/contactInformation";
import HomeSetup from "./formPages/homeSetup";
import PowerAccess from "./formPages/powerAccess";
import Preferences from "./formPages/preferences";
import Quote from "./formPages/quote";
import ReviewDetails from "./formPages/reviewDetails";
import SelectEstimate from "./formPages/selectEstimate";
import VehicleTypePage from "./formPages/vehicleTypePage";

export interface ChargerEstimatorPageItem {
  pageName: string;
  component: (
    chargerEstimatorData: ChargerEstimatorData,
    setChargerEstimatorData: React.Dispatch<
      React.SetStateAction<ChargerEstimatorData>
    >,
  ) => JSX.Element;
}

export const ChargerEstimatorPages: ChargerEstimatorPageItem[] = [
  {
    pageName: "addressPage",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <AddressPage
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "chargerLocation",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <ChargerLocationPage
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "vehicleType",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <VehicleTypePage
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "homeSetup",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <HomeSetup
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "powerAccess",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <PowerAccess
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "preferences",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <Preferences
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "contactInformation",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <ContactInformation
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "reviewDetails",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <ReviewDetails
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
  {
    pageName: "quote",
    component: () => <Quote />,
  },
  {
    pageName: "selectEstimate",
    component: (chargerEstimatorData, setChargerEstimatorData) => (
      <SelectEstimate
        chargerEstimatorData={chargerEstimatorData}
        setChargerEstimatorData={setChargerEstimatorData}
      />
    ),
  },
];
